import React from 'react';
import P from 'prop-types';
import styled from '@emotion/styled';
import { Field, useField } from 'formik';
import FieldContainer from '../form/Misc/FieldContainer';

const TextArea = props => {
  const { label, name, placeholder, RTL, disabled } = props;
  const [field, meta, form] = useField(name);
  const { touched, error } = meta;
  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <div className='form-group '>
            <label htmlFor={name}>{label} :</label>
            <FieldContainer errorMessage={error} className='col-lg-9'>
              <textarea
                disabled={disabled}
                style={{ direction: RTL ? 'rtl' : 'ltr' }}
                {...field}
                id={name}
                className='form-control'
                spellCheck='false'
                placeholder={placeholder}
                rows="10"
              />
            </FieldContainer>
          </div>
        );
      }}
    </Field>
  );
};

// const FieldContainer = styled.div`
//   position: relative;
//   padding-bottom: "15px";
// `;

TextArea.propTypes = {
  name: P.string.isRequired,
  label: P.string,
  placeholder: P.string,
  RTL: P.bool,
  disabled: P.bool
};

TextArea.defaultProps = {
  RTL: false,
  disabled: false
};

export default TextArea;
